const getExternalMediaPreviewUrl = (asset) => {
  const sizes = [
    asset.sizes?.web_stories_thumbnail,
    asset.sizes?.large,
    asset.sizes?.preview,
    asset.sizes?.full,
  ];

  return (
    sizes.find((size) => size?.source_url && size.requestFullUrl !== true)
      ?.source_url || ''
  );
};

export const map3pToExternalMedia = (asset) => {
  const previewUrl = getExternalMediaPreviewUrl(asset);
  const hasDimensions = asset.width > 0 && asset.height > 0;

  return {
    ...asset,
    id: asset.id,
    externalId: asset.id,
    creationTime: asset.creationDate,
    displayDuration: asset.lengthFormatted?.replaceAll(' ', ''),
    metadata: {
      filetype: asset.mimeType,
      title: asset.title,
      height: asset.height,
      width: asset.width,
    },
    playcardSmallUrl: asset.type === 'video' ? asset.poster : previewUrl,
    playcardUrl: asset.poster,
    ratio: hasDimensions ? asset.width / asset.height : 1,
    title: asset.title,
    thumbnailUrl: asset.type === 'video' ? asset.poster : previewUrl,
    url: asset.src,
    videoUrl: asset.type === 'video' ? asset.src : '',
  };
};

export const mapExternalMediaTo3p = (asset) => {
  const formatNumber = (number) => {
    if (typeof number === 'number') {
      return number;
    }

    if (typeof number === 'string') {
      return isNaN(parseInt(number)) ? 0 : parseInt(number);
    }

    return 0;
  };

  return {
    ...asset,
    alt: asset.title ?? asset.metadata?.title,
    height: formatNumber(asset.metadata?.height),
    lengthFormatted: asset.displayDuration || '',
    id: asset.id,
    mimeType: asset.metadata?.filetype || getMimeTypeFromUrl(asset.url),
    poster: asset.playcardUrl,
    sizes: asset.sizes || {},
    src: asset.url,
    title: asset.title ?? asset.metadata?.title,
    type:
      asset.metadata?.filetype?.split('/')[0] ||
      getMimeTypeFromUrl(asset.url)?.split('/')[0],
    width: formatNumber(asset.metadata?.width),
  };
};

const getMimeTypeFromUrl = (url) => {
  const extension = url.split('.').pop();

  if (['gif', 'jpe', 'jpeg', 'jpg', 'png'].includes(extension)) {
    return `image/${extension === 'jpg' ? 'jpeg' : extension}`;
  }

  if (['mov', 'm4v', 'mp4', 'png', 'webm'].includes(extension)) {
    return `video/${extension}`;
  }

  return undefined;
};
